import { FC } from "react";
import BreadcrumbGroup from "@cloudscape-design/components/breadcrumb-group";
import { BucketPathSegment } from "../../../../../../domain/entities/UserProfileEntity";

interface BucketBreadcrumbProps {
    bucketPath: BucketPathSegment[];
}

const BucketBreadcrumb: FC<BucketBreadcrumbProps> = ({ bucketPath }) => {
    if (!bucketPath || bucketPath.length === 0) {
        return <span>No bucket assigned</span>;
    }

    return (
        <BreadcrumbGroup
            items={bucketPath.map((segment) => ({
                text: segment.name,
                href: "#",
            }))}
        />
    );
};

export default BucketBreadcrumb;
